import gtLogo from "../asset/img/gt-logo.png";
import gsuLogo from "../asset/img/gsu-logo.jpg"

export const Education = () => {
    return (
    <section className="education" id="education">
    <h1 class="heading">Education</h1>
      <div className="box-container">
          <div className="box">
            <div className="image">
              <img src={gtLogo} alt="" style={{ width: 180, height: 110 }} />
            </div>
            <div className="content">
              <h3>Georgia Institute of Technology</h3>
              <p>Bachelor of Science, Computer Science | Concentration: Intelligence and Media</p>
              <h4>2023-Present | Expected Graduation: December 2025</h4>
              <p1>Relevant Courseworks: Data Structures & Algorithms, Objects & Design, Computer Organization & Programming, Design & Analysis of Algorithms, Artifical Intelligence, Machine Learning, Perception & Robotics, Applied Combinatorics, Probability & Statistics</p1>
            </div>
          </div>

          <div className="box">
            <div className="image">
              <img src={gsuLogo} alt="" style={{ width: 150, height: 150 }} />
            </div>
            <div className="content">
              <h3>Georgia State University</h3>
              <p>Bachelor of Science, Computer Science</p>
              <h4>2021-2023</h4>
              <p1>Relevant Courseworks: Object-Oriented Programming, Linear Algebra, Discrete Mathematics</p1>
            </div>
          </div>
        </div>
    </section>
  )
}
    